// Module
var code = "<a class=nlgAnalysisTreePropertyIcon name=nodeDownloadAttachAction ng-mousedown=execute($event) ng-class=\"property.innerNodeProperty.value ? 'hasAttachment' : 'missingAttachment'\"> <i ng-class=\"{'fa fa-paperclip': property.innerNodeProperty.value}\" style=margin-top:0></i> </a>";
// Exports
module.exports = code;